import {InstrumentActionTypes} from 'constants/actionType';
import {InstrumentStatusType} from 'constants/dataEnum';

const initialState = {
  eStopTriggered: false,
  isSimulationMode: null,
  isAutomationMode: null,
  instrumentStatus: InstrumentStatusType.OPERATIONAL,
  instrumentServiceStatus: {
    hasError: false,
    errorCode: null,
  },
  labwareServiceStatus: {
    hasError: false,
    errorCode: null,
  },
  motorErrorData: {},
};

export default function instrumentStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case InstrumentActionTypes.SET_ESTOP_TRIGGERED:
      return {...state, eStopTriggered: action.data};
    case InstrumentActionTypes.SET_IS_SIMULATION_MODE:
      return {...state, isSimulationMode: action.data};
    case InstrumentActionTypes.SET_IS_AUTOMATION_MODE:
      return {...state, isAutomationMode: action.data};
    case InstrumentActionTypes.SET_INSTRUMENT_STATUS:
      return {...state, instrumentStatus: action.data};
    case InstrumentActionTypes.SET_INSTRUMENT_SERVICE_STATUS:
      return {...state, instrumentServiceStatus: action.data};
    case InstrumentActionTypes.SET_LABWARE_SERVICE_STATUS:
      return {...state, labwareServiceStatus: action.data};
    case InstrumentActionTypes.SET_MOTOR_ERROR_DATA:
      return {...state, motorErrorData: action.data};
    case InstrumentActionTypes.RESTORE_INSTRUMENT_STATE:
      return action.state;
    default:
      return state;
  }
}
